import { connect, mapProps, mapReadPretty, ReactFC, useForm } from '@formily/react'
import React from 'react'
import { Skeleton } from 'antd'
import { withContainer } from '../../common/Container'
import './styles.less'

export const ChildBox = ({children, ...props}: any) => {
  if(!children) {
    return <div className='fromily-empty-child-box' {...props} >
      <div className='fromily-empty-child-box-text'>子页面占位容器</div>
      <Skeleton />
    </div>
  }
  return <div className='fromily-child-box' {...props} >{children}</div>
}

const FormilyChildBox: ReactFC<any> = connect(ChildBox)

export default FormilyChildBox
